import client from "src/services/client";
import { jobAction, jobId, modalOpen, toastMessage } from "src/store/store";
import { extractErrorMessage, capitalize } from "src/utils/misc";
export async function handleJob(action, reasonId, refetch) {
    // api call here
    // action can be "Delete" or "Complete"
    let actionEndpoint = action;
    if (action === "delete") {
        actionEndpoint = "cancel";
    }
    try {
        let id;
        jobId.subscribe((value) => {
            id = value;
        });
        const res = await client(`/v1/Jobs/${id}/${capitalize(actionEndpoint)}`, {
            method: "POST",
            version: "Tasking",
            data: {
                reasonId,
            },
        });
        if (res.data.error_code === 400) {
            extractErrorMessage(res.data.error_msg);
        }
        else {
            modalOpen.set(false);
            toastMessage.set({ message: `Job ${action}d`, type: "success" });
            refetch();
        }
    }
    catch (error) {
        console.log(error);
        extractErrorMessage(error);
    }
}
export function setJobAction(action, id) {
    jobAction.set(action);
    jobId.set(id);
    modalOpen.set(true);
}
